import React from 'react';
import { Link } from 'react-router-dom'

export default function Intimation(){
  return (
     <div>
     {/* Header Start */}
	  <div className="container-fluid hero-header bg-light py5 mb-5"  style={{"padding-top":"1rem !important","padding-bottom":"1rem !important"}}>
		<div className="container py-5">
		  <div className="row g-5 align-items-center">
			<div className="col-lg-12">
			  <h1 className="display-4 mb3 animated slideInDown">Intimation</h1>
			  <nav aria-label="breadcrumb animated slideInDown">
				<ol className="breadcrumb mb-0">
				  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
				  <li className="breadcrumb-item"><Link to="/">Investor Relation</Link></li>
				  <li className="breadcrumb-item"><Link to="/">Board Meetings</Link></li>
				  <li className="breadcrumb-item active" aria-current="page">Intimation</li>
				</ol>
			  </nav>
			</div>
			
			
		  </div>
		</div>
	  </div>
	  {/* Header End */}
	  {/* About Start */}
	  <div className="container-xxl py5">
		<div className="container">
		  <div className="row g-5 align-items-center">
			  <div className="table-responsive table_heading">
			  <table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">Intimation Reports 2026-27</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
					<tr>
					  <td>Intimation-10.08.2026</td>
					  <td width={280} className="text-center">
						<Link to="/Intimation/Intimation-10.08.2026.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Intimation 30.05.2026</td>
					  <td width={280} className="text-center">
						<Link to="/Intimation/Intimation_30-05-2026.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				  </tbody>
				</table>
				<table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">Intimation Reports 2025-26</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
					<tr>
						<td>Intimation 12.02.2026</td>
						  <td width={280} className="text-center">
							<Link to="/Intimation/Intimation-12-02-2026.pdf" target="_blank">
							Download
						   </Link>{" "}
						 </td>
					</tr>

				<tr>
				  <td>Intimation 14.11.2025</td>
					  <td width={280} className="text-center">
						<Link to="/Intimation/Intimation-14-11-2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					  </tr>
				  <tr>
					<td>intimation of BM_12.08.2025</td>
					  <td width={280} className="text-center">
						<Link to="/Intimation/intimation-of-BM-12-08-2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Intimation 08.05.2025</td>
					  <td width={280} className="text-center">
						<Link to="/Intimation/08th-May-2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Intimation 01.05.2025</td>
					  <td width={280} className="text-center">
						<Link to="/Intimation/Intimation_01.05.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Intimation Revised 07.05.2025</td>
					  <td width={280} className="text-center">
						<Link to="/Intimation/Intimation_Revised_07.05.205.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				  </tbody>
				</table>
				<table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">Intimation Reports 2024-25</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
				    <tr>
					  <td>Intimation 01.02.2025</td>
					  <td width={280} className="text-center">
						<Link to="/Intimation/Intimation_01.02.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Intimation 29.07.2024</td>
					  <td width={280} className="text-center">
						<Link to="/Intimation/Intimation_29.07.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
				  </tbody>
				</table>
				<table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">Intimation Reports 2021-22</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
					<tr>
					  <td>Intimation 21.05.2021</td>
					  <td width={280} className="text-center">
						<Link to="/Intimation/Intimation_21.05.2021.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				  </tbody>
				</table>
			  </div>
		  </div>
		</div>
	  </div>
	  {/* About End */}
	</div>
    );
}